import { SUBMISSION_STATUS, SubmissionStatuses } from '@crazygames/game-types/src/submission/submission-status.type';
import { isDefined } from '@crazygames/utils/isDefined';

interface SectionData {
  id: string;
  name: string;
  defaultCollapsedStatuses?: SUBMISSION_STATUS[];
}

export const SECTIONS: { [k: string]: SectionData } = {
  submissionDetails: {
    id: 'submission-details',
    name: 'Submission details',
  },
  internalNotes: {
    id: 'internal-notes',
    name: 'Internal notes',
  },
  gameStatuses: {
    id: 'game-statuses',
    name: 'Game statuses',
  },
  gameDetails: {
    id: 'game-details',
    name: 'Game details',
  },
  featuringFlags: {
    id: 'featuring-flags',
    name: 'Featuring & flags',
    defaultCollapsedStatuses: [
      'DRAFT',
      'NEW_SUBMISSION',
      'BASIC_LAUNCH_REQUIRES_APPROVAL',
      'BASIC_LAUNCH',
      'BASIC_LAUNCH_SYNC_REQUIRED',
      'BASIC_LAUNCH_MIXED_RESULT',
      'BASIC_LAUNCH_MIXED_RESULT_SYNC_REQUIRED',
      'BASIC_LAUNCH_APPROVED',
      'BASIC_LAUNCH_AWAITING_DEVELOPER_CHANGE',
    ],
  },
  seo: {
    id: 'seo',
    name: 'SEO',
    defaultCollapsedStatuses: [
      'DRAFT',
      'NEW_SUBMISSION',
      'BASIC_LAUNCH_REQUIRES_APPROVAL',
      'BASIC_LAUNCH',
      'BASIC_LAUNCH_SYNC_REQUIRED',
      'REQUIRES_APPROVAL',
      'RELEASED',
      'SYNC_REQUIRED',
      'BASIC_LAUNCH_MIXED_RESULT',
      'BASIC_LAUNCH_MIXED_RESULT_SYNC_REQUIRED',
      'BASIC_LAUNCH_APPROVED',
      'PREPARING_RELEASE',
      'BASIC_LAUNCH_AWAITING_DEVELOPER_CHANGE',
    ],
  },
  submission: {
    id: 'submission',
    name: 'Submission',
    defaultCollapsedStatuses: [
      'DRAFT',
      'NEW_SUBMISSION',
      'BASIC_LAUNCH_REQUIRES_APPROVAL',
      'BASIC_LAUNCH',
      'BASIC_LAUNCH_SYNC_REQUIRED',
      'RELEASED',
      'SYNC_REQUIRED',
      'BASIC_LAUNCH_MIXED_RESULT',
      'BASIC_LAUNCH_MIXED_RESULT_SYNC_REQUIRED',
      'BASIC_LAUNCH_APPROVED',
    ],
  },
  art: {
    id: 'art',
    name: 'Art',
  },
  gameBuilds: {
    id: 'game-builds',
    name: 'Game builds',
  },
  developerCommunication: {
    id: 'developer-communication',
    name: 'Developer communication',
    defaultCollapsedStatuses: ['BASIC_LAUNCH', 'RELEASED', 'BASIC_LAUNCH_MIXED_RESULT'],
  },
  technicalAnnotations: {
    id: 'technical-annotations',
    name: 'Technical annotations',
    // collapsed for all statuses
    defaultCollapsedStatuses: [...SubmissionStatuses],
  },
};

/** QA team wants various sections on admin game page expanded/collapsed by default depending on submission status. */
export function getSectionDefaultExpanded(section: SectionData, submissionStatus: SUBMISSION_STATUS | undefined): boolean {
  if (!isDefined(section.defaultCollapsedStatuses)) {
    return true;
  }
  return !section.defaultCollapsedStatuses.includes(submissionStatus as SUBMISSION_STATUS);
}
